import { useEffect } from "react";

import { useFeedbackButtonsStore } from "./FeedbackDrawerStore";

/**
 * Hide the floating Give/Request Feedback buttons while `active` is true — e.g. while a
 * side panel is open — so they don't overlap its content. The drawers stay mounted, so
 * other entry points can still open them. Visibility is restored on deactivate/unmount.
 */
export const useSuppressFeedbackButtons = (active: boolean): void => {
	const setForceHidden = useFeedbackButtonsStore((state) => state.setForceHidden);

	useEffect(() => {
		setForceHidden(active);
		return () => setForceHidden(false);
	}, [active, setForceHidden]);
};
